import { useSelector } from "react-redux";

import { selectAuth } from "@redux";
import UserStore from "@Rocket-Innovation/components/store/UserStore";
import { useEffect } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";

export const PageRedirectToSubscriptionNoCode = () => {
    //page hook
    const hostname = window.location.hostname;
    const prefix = hostname.split(".")[0] as string;
    const history = useHistory();
    const { userInfo, auth } = useSelector(selectAuth);
    const accessToken = auth ?? UserStore((s: any) => s.accessToken);

    useEffect(() => {
        window.open(`https://${prefix}.rocket-subscriptions.app?token=${accessToken}`, "_self");
    }, [accessToken]);

    return <StyledContainer></StyledContainer>;
};

const StyledContainer = styled.div`
    height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
